"use client";

import { ChevronRight } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Services() {
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const {
    ref: gridRef,
    isVisible: gridVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const disciplines = [{
    number: "01",
    title: "Commercial Cooling",
    description: "High-performance climate control systems engineered for office spaces and retail environments. We ensure optimal productivity through precise temperature management.",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1717132/img/commercial_cooling.webp",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1717132/img/commercial_cooling.webp-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1717132/img/commercial_cooling.webp-wvc-sizes",
    alt: "Modern office space with integrated air conditioning"
  }, {
    number: "02",
    title: "Residential Comfort",
    description: "Bespoke climate solutions for your home. Our quiet, energy-efficient systems provide year-round comfort, tailored to your specific living requirements.",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1717132/img/residential_comfort.webp",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1717132/img/residential_comfort.webp-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1717132/img/residential_comfort.webp-wvc-sizes",
    alt: "Comfortable living room with wall-mounted climate unit"
  }, {
    number: "03",
    title: "System Maintenance",
    description: "Proactive care to extend the lifespan of your equipment. Our expert technicians provide thorough inspections and rapid repairs to keep your systems running perfectly.",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1717132/img/system_maintenance.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1717132/img/system_maintenance.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1717132/img/system_maintenance.png-wvc-sizes",
    alt: "Technician performing maintenance on an AC unit"
  }];
  return <section data-section-id="2840" id="systemofferingsgrid" className="bg-background text-foreground py-32 md:py-40 lg:py-[10rem] overflow-hidden">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 lg:px-16">
        {}
        <div ref={headerRef} className={`grid grid-cols-1 lg:grid-cols-[60%_40%] gap-10 lg:gap-16 mb-20 md:mb-28 transition-all duration-1000 ease-out ${headerVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <div>
            <p className="font-default text-[11px] tracking-[0.25em] uppercase mb-8 md:mb-10 text-primary">
              Our Expertise — 02
            </p>
            <h2 className="font-default text-5xl md:text-6xl lg:text-[5rem] leading-[1.05] tracking-tight text-foreground">
              Professional Climate
              <br />
              Control{" "}
              <em className="italic font-light text-primary">
                Solutions
              </em>
              .
            </h2>
          </div>
          <div className="flex items-end">
            <p className="font-default text-base md:text-[15px] leading-[1.7] max-w-md text-muted-foreground">
              At Coastline Air Conditioning Services, we deliver superior air conditioning and climate management. 
              From commercial installations to residential comfort, our services are 
              designed to provide reliable, efficient, and quiet performance.
            </p>
          </div>
        </div>

        {}
        <div ref={gridRef} className={`grid grid-cols-1 md:grid-cols-3 transition-all duration-1000 ease-out delay-200 ${gridVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          {disciplines.map((item, i) => <article data-index={i} key={item.number} className="group relative aspect-[4/5] overflow-hidden border border-border rounded-lg hover:border-primary/60 transition-all duration-700 cursor-pointer shadow-md">
              {}
              <div className="absolute inset-0 overflow-hidden">
                <img src={item.image} data-wvc-srcset={item.srcset} data-wvc-sizes={item.sizes} alt={item.alt} loading="lazy" decoding="async" className="w-full max-w-full h-full object-cover transition-transform duration-[800ms] ease-out group-hover:scale-105" />
                {}
                <div className="absolute inset-0 transition-opacity duration-700 bg-gradient-to-t from-black/90 to-black/20" />
              </div>

              {}
              <div className="absolute top-8 left-8 md:top-10 md:left-10 z-10">
                <span className="font-default text-[11px] tracking-[0.25em] text-primary">
                  {item.number}
                </span>
              </div>

              {}
              <div className="absolute bottom-8 right-8 md:bottom-10 md:right-10 z-10 transition-transform duration-500 group-hover:translate-x-1">
                <ChevronRight className="w-5 h-5 text-primary" strokeWidth={2} />
              </div>

              {}
              <div className="absolute bottom-8 left-8 md:bottom-10 md:left-10 right-16 md:right-20 z-10">
                <h3 className="font-default text-2xl md:text-3xl lg:text-[2rem] leading-tight text-white transition-transform duration-500 ease-out md:group-hover:-translate-y-2">
                  {item.title}
                </h3>
                <p className="font-default text-sm leading-[1.65] mt-4 md:mt-0 md:opacity-0 md:max-h-0 md:overflow-hidden md:group-hover:opacity-100 md:group-hover:max-h-40 md:group-hover:mt-4 transition-all duration-500 ease-out text-gray-200">
                  {item.description}
                </p>
              </div>
            </article>)}
        </div>
      </div>
    </section>;
}